module.exports = __webpack_public_path__ + "img/pro_beijia_06.26c3014d.jpg";